<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon> Rechazar permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-container grid-list-md class="p-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <h4 class="texto-rechazar">
                <b>Número:</b> {{ permiso.numero }}
              </h4>
            </v-flex>
            <v-flex xs12>
              <span class="texto-rechazar"
                ><b>Funcionario:</b> {{ permiso.nombres }}</span
              >
            </v-flex>
            <v-flex xs12>
              <span class="texto-rechazar">
                <b>Tipo de papeleta:</b> {{ permiso.tipo_permiso }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
              <span class="texto-rechazar">
                <b>Lugar de atencion:</b> {{ permiso.lugar_atencion }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 87">
              <span class="texto-rechazar"
                ><b>Lugar de comisión :</b> {{ permiso.lugar }}</span
              >
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 87 || permiso.id_tipo_permiso == 96
              "
            >
              <span class="texto-rechazar"
                ><b>Motivo:</b> {{ permiso.motivo }}</span
              >
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 90">
              <span class="texto-rechazar"
                ><b>Tipo de baja:</b> {{ permiso.motivo }}</span
              >
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <span class="texto-rechazar">
                <b>Fecha de nacimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <span class="texto-rechazar">
                <b>Hora de nacimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <span class="texto-rechazar">
                <b>Fecha de fallecimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <span class="texto-rechazar">
                <b>Hora de fallecimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '12'">
              <span class="texto-rechazar">
                <b>Fecha de matrimonio:</b>
                {{ $moment(permiso.fecha_nac_muerte).format("DD-MM-YY") }}
              </span>
            </v-flex>
          </v-layout>

          <v-flex xs12>
            <span class="subtitulo-rechazar"><b>Detalles de papeleta.</b></span>
          </v-flex>
          <v-layout>
            <v-flex xs12>
              <!-- permisos por horas -->
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_horas"
                v-if="
                  permiso.id_tipo_permiso == 87 ||
                    permiso.id_tipo_permiso == 96 ||
                    permiso.id_tipo_permiso == 88 ||
                    (permiso.id_tipo_permiso >= 37 &&
                      permiso.id_tipo_permiso <= 43)
                "
              >
                >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.horas_permiso }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias decimales -->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias_decimales"
                v-if="
                  permiso.id_tipo_permiso == 14 ||
                    (permiso.id_tipo_permiso >= 98 &&
                      permiso.id_tipo_permiso <= 101) ||
                    permiso.id_tipo_permiso == 89 ||
                    permiso.id_tipo_permiso == 18
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias completos-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias"
                v-if="
                  permiso.id_tipo_permiso == 6 ||
                    permiso.id_tipo_permiso == 44 ||
                    permiso.id_tipo_permiso == 95 ||
                    permiso.id_tipo_permiso == 61 ||
                    permiso.id_tipo_permiso == 12 ||
                    permiso.id_tipo_permiso == 90
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos 94 formulario de registro de asistencias-->
          <v-layout v-if="permiso.id_tipo_permiso == 94">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!--permiso 24-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers"
                v-if="permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

          <span
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
            class="subtitulo-rechazar"
          >
            <b>Detalles compensacion</b>
          </span>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_compensacion"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout class="pa-2">
            <v-flex xs12>
              <h4
                v-if="
                  permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
                "
              >
                <b>Total horas: {{ total_horas_acomuladas }}</b>
              </h4>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <span class="subtitulo-rechazar"
              ><b>Seguimiento de la papeleta</b></span
            >
          </v-flex>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers_seg_detalle"
                :items="detalle_seguimiento"
                class="tabla-comprimida-light elevation-1"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item._created_at).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.estado }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.usuario ? props.item.usuario : "" }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md12>
              <v-textarea
                class="text-field-reducido-border"
                v-model="form.justificacion_rechazo"
                auto-grow
                rows="2"
                label="Justificación del rechazo"
                :rules="$validate(['required'])"
                required
                outline
                clearable
              >
              </v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click.prevent="close()" :loading="loading"
          ><v-icon>close</v-icon>
          Cancelar
        </v-btn>

        <v-btn color="error" @click="apruebaRechazaPermiso(permiso)"
          ><v-icon>clear</v-icon>
          Rechazar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogRechazarPermisoOficialPorHoras", item => {
      this.permiso = item;
      this.total_horas();
      this.cargarDetallesPermiso();
      this.verPermisosCompensacion(parseInt(this.permiso.id_permiso));
      this.permiso.motivo_rechazo = "";
      this.getDetallePermiso(parseInt(this.permiso.id_permiso));
      this.getDetalleSeguimiemto(parseInt(this.permiso.id_permiso));
      this.dialog = true;
    });
  },
  data() {
    return {
      dialog: false,
      permiso: {
        motivo_rechazo: ""
      },
      form: {},
      permiso_detalles2: [],
      permiso_compensacion: [],
      permiso_detalles: [],
      detalle_seguimiento: [],
      total_horas_acomuladas: 0,
      loading: false,
      horas_solicitadas_comp: 0,
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        // {
        // 	text: 'Hora desde',
        // 	sortable: false,
        // 	align: 'center'
        // },
        // {
        // 	text: 'Hora hasta',
        // 	sortable: false,
        // 	align: 'center'
        // },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_seg_detalle: [
        // { text: 'Número', sortable: false, align: 'center'},
        { text: "Fecha de registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario Registro", sortable: false, align: "center" }
      ],

      horas_solicitadas: 0
    };
  },
  methods: {
    async cargarDetallesPermiso() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			    query{
					vPermisosPorFuncionarios(id_permiso:"${this.permiso.id_permiso}"){
					rows{
						id_permiso
							id_persona
							nombres
							numero
							fecha_desde
							fecha_emision
							tipo_permiso
							fecha_retorno
							estado_permiso
							nro_dias
							hora_desde
							hora_hasta
							id_lugar
							lugar_atencion
							fecha_nac_muerte
							hora_nac_muerte
							tipo_nac_muerte
							rango_horario
							rechazo
							horas_permiso
							id_tipo_permiso
							compensa_tolerancia
							permiso{
							id
							motivo
							id_tipo_permiso
							ruta_archivo
							tipo_permiso{
								id
								id_parametro_elaborado
							}
							fecha_permiso
							numero
							fecha_registro
							id_estado
							lugar        
							
							estado{
								descripcion
							}
							
							
							}
						}
			}
				}
              `
        });
        console.log();
        this.permiso_detalles2 = respuesta.vPermisosPorFuncionarios.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.run.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });

        this.permiso_compensacion = respuesta.runQuery.respuesta;
        this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },
    sumar_horas_compensa(permiso_detalles) {
      let total_comp = 0;
      permiso_detalles.forEach(item => {
        total_comp +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas_comp = total_comp;
    },
    close() {
      this.dialog = false;
      this.permiso = {
        motivo: ""
      };
      this.$bus.$emit("closeDialogRechazaPermiso");
    },

    sumar_horas(permiso_detalles) {
      let total = 0;
      permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas = total;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
             query{
              vDetallePermisos(lista_estados:"9,6,7,16,21",id_permiso:${id}){
                rows{
                  id
                  id_permiso
                  id_estado_detalle
                  fecha_desde
                  fecha_hasta
                  fecha_desde_compensa
                  hora_desde
                  hora_hasta
                  horas_compensa
                  fecha_permiso
				  total_dias
				  rango_horario
                }
              }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaRechazaPermiso(permiso) {
      try {
        if (!this.form.justificacion_rechazo) {
          this.$message.info("No lleno el justificativo de rechazo");
          return;
        }
        this.$confirm("¿Está seguro de rechazar el permiso?", async () => {
          this.form.justificacion_rechazo = this.form.justificacion_rechazo.replace(
            /\n/g,
            " "
          );
          const user = this.$storage.get("user");
          let respuesta = "";
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_rechazo_permisos_por_jefes_rrhh(${permiso.id_permiso},${user.id},'${this.form.justificacion_rechazo}','','{}')"){
                  respuesta
                }
              }
            `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_rechazo_permisos_por_jefes_rrhh;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            // Enviamos correo de rechazo
            let datos_persona_permiso = await this.obtenerDatosPersonaCorreo(
              permiso.id_funcionario
            );
            if (datos_persona_permiso) {
              var mensaje = `
              <h1>NOTIFICACIÓN - RECHAZO DE PERMISO</h1>
              Estimado(a): ${datos_persona_permiso.nombres} ${
                datos_persona_permiso.ap_paterno
              } ${datos_persona_permiso.ap_materno}<br>
              Comunicarle que la papeleta con los siguientes datos:<br>
              <b>NRO DE PAPELETA:</b><br>${permiso.numero}<br>
              <b>TIPO DE PERMISO:</b><br>${permiso.tipo_permiso}<br>
              <b>FECHA DEL PERMISO:</b><br>${permiso.fecha_desde} - ${
                permiso.fecha_retorno
              }<br><br>
              Fue rechazada por el siguiente motivo:<br>
              ${this.form.justificacion_rechazo.toUpperCase()}<br><br>
              Ingrese al sistema para ver mas detalles.
              `;
              await this.$service.sendEmail({
                correo: datos_persona_permiso.correo,
                asunto: `NOTIFICACIÓN - RECHAZO DE PERMISO SAP`,
                mensaje: mensaje.replace(/<[^>]+>/g, ""),
                html: mensaje
              });
            } else {
              this.$message.info(
                "No se notifico por correo ya que el servidor no posee un correo registrado"
              );
            }
            this.$alert("El permiso fué rechazado", () => {});
            this.close();
          } else {
            this.$alert(resps2[1], () => {});
            this.close();
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para obtener los datos de la persona
    async obtenerDatosPersonaCorreo(id_persona) {
      try {
        let rpta = await this.$service.graphql({
          query: `
          query{
            persona(id:${id_persona}){
              ap_paterno
              ap_materno
              nombres
              usuarios{
                correo
              }
            }
          }
        `
        });
        var datos_persona = rpta.persona;
        if (datos_persona) {
          datos_persona = {
            ap_paterno: datos_persona.ap_paterno,
            ap_materno: datos_persona.ap_materno,
            nombres: datos_persona.nombres,
            correo: datos_persona.usuarios[0]
              ? datos_persona.usuarios[0].correo
              : null
          };
        }
        return datos_persona;
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaRechazaPermisoOld(permiso, id_estado) {
      if (!this.form.justificacion_rechazo) {
        return;
      }
      const user = this.$storage.get("user");
      let respuesta = "";
      if (this.permiso.id_tipo_permiso == 87) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
            // this.$message.error(resps2[1])
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 6) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_aprueba_duelo(${permiso.id_permiso},16,${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_duelo;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 102) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_anula_o_rechaza_horario_continuo(${permiso.id_permiso},16,${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_anula_o_rechaza_horario_continuo;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 61) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_aprueba_paternidad(${permiso.id_permiso},16,${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_paternidad;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 88) {
        try {
          console.log(`
                            query{
                              runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},16,${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `);
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},16,${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });
          console.log(
            respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial
          );
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 14) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_aprueba_lic_personal(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_lic_personal;
          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto == 1) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 24) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                                        query{
                                          runQuery(consulta:"select control.fn_aprueba_cta_vacacion(${permiso.id_permiso},'${id_estado}','${user.id_persona}','${user.id}','${this.form.justificacion_rechazo}')"){
                                            respuesta
                                          }
                                        }
                                      `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_cta_vacacion;

          let resps = resp.split("|");
          let correcto = resps[0];
          //console.log(correcto);
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 94) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_aprueba_permiso_oficial(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_oficial;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      //CJTO DE PERMISOS TOLERANCIA
      if (
        this.permiso.id_tipo_permiso >= 37 &&
        this.permiso.id_tipo_permiso <= 43
      ) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select control.fn_aprueba_pap_pros (${permiso.id_permiso},${id_estado},${user.id_persona},'${this.form.justificacion_rechazo}')"){
                                respuesta
                              }
                            }
                          `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_pap_pros;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso se rechazo", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 12) {
        try {
          console.log(`
              query{
                
                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_matrimonio_superior(${permiso.id_permiso},'${id_estado}','${user.id}',${user.id_persona},'${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `);
          respuesta = await this.$service.graphql({
            query: `
              query{
                
                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_matrimonio_superior(${permiso.id_permiso},'${id_estado}','${user.id}',${user.id_persona},'${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `
          });
          let resp =
            respuesta.runQuery.respuesta[0]
              .fn_aprueba_rechaza_permiso_matrimonio_superior;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso se rechazo", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.close();
    }
  }
};
</script>
<style scoped>
.texto-rechazar {
  font-size: 1.3rem;
  color: rgb(24, 106, 121);
  margin: 0 !important;
}
.subtitulo-rechazar {
  font-size: 1.35em;
  color: rgb(24, 106, 121);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/RechazarPermisoOficialPorHoras.vue